import cn from './zh-cn';
import {LocalesData} from '../interface';

export const locale = 'zh';

export const messages: LocalesData = {
    zh: cn,
};
